import React from "react";

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    hasError?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
                                               hasError = false,
                                               className = "",
                                               ...props
                                           }) => {
    return (
        <textarea
            className={`ui-textarea ${hasError ? "ui-textarea-error" : ""} ${className}`.trim()}
            {...props}
        />
    );
};

export default Textarea;
